(function (TeamAPI, TeamScheduleAPI, _) {

    "use strict";
    angular.module("harriApp")
        .directive('employeeRoles', ['$filter', 'EditRolesForm', "TeamCommunicationService", "TeamScheduleService", "$timeout", function ($filter, EditRolesForm, TeamCommunicationService, TeamScheduleService, $timeout) {
            return {
                restrict: "E",
                replace: 'true',
                scope: {
                    brandId: '=',
                    member: '='
                },
                templateUrl: '../modules/team_schedule/employer/roles/views/employee_roles_directive.html',
                link: function ($scope, formElement, attrs) {

                    TeamScheduleService.getActiveBrand()
                        .then(function (brand) {
                            $scope.brand = brand;
                            $scope.isClockTimeEnabled = TeamScheduleService.isClockTimeAppEnabled();
                        });

                    $scope.editRolesForm = new EditRolesForm($scope);
                    $scope.isEditing = false;
                    $scope.loading = false;

                    var _tcService = new TeamCommunicationService();

                    $scope.isFutureDate = function (date) {
                        return moment(date).isAfter();
                    };

                    /**
                     * Show member roles and wages data
                     */
                    $scope.showRoles = function () {

                        $scope.loading = true;
                        $scope.isRolesShown = true;

                        TeamAPI.getMemberRoles($scope.brandId, $scope.member.id)
                            .then(function (roles) {

                                roles.roles = roles.roles || [];

                                roles.roles.forEach(function (role) {
                                    if (role.pay_rate && role.pay_rate.pay_rate_code) {
                                        var rate = role.pay_rate.pay_rate_code;
                                        var symbol = $filter('locationCurrencySymbol')($scope.brand);
                                        rate.name = rate.code + " (" + $filter('currency')(rate.rate, symbol) + ")";
                                    }
                                });

                                $scope.loading = false;
                                $scope.roles = roles;
                                $scope.originalRoles = angular.copy(roles);
                                if ($scope.roles.hire_date) {
                                    $scope.roles.hire_date = moment($scope.roles.hire_date, "MMM D, YYYY").format("MMM D, YYYY");
                                    $scope.originalRoles.hire_date = moment($scope.roles.hire_date, "MMM D, YYYY").format("MMM D, YYYY");
                                }

                                try {
                                    $scope.$digest();
                                } catch (e) {
                                }

                            }, function (error) {

                                $scope.loading = false;
                                $scope.isRolesShown = false;
                                console.error(error);
                                hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong"));
                                try {
                                    $scope.$digest();
                                } catch (e) {
                                }

                            });
                    };

                    $scope.showRoles();

                    /**
                     * Validates and saves roles and wages
                     */
                    $scope.saveRoles = function () {
                        $scope.loading = true;
                        var updatedRoles = {
                            hire_date: $scope.roles.hire_date,
                            max_weekly_hours: $scope.roles.max_weekly_hours,
                            roles: []
                        };

                        if (!$scope.roles.roles || ($scope.roles.roles && $scope.roles.roles.length == 0)) {
                            hAlert( $filter("translate")("Error"),
                                $filter("translate")("Member must be assigned to at least one position.")
                            );
                            $scope.loading = false;
                            return;
                        }

                        var posCounter = _.countBy($scope.roles.roles, function (role) {
                            return role.position.code;
                        });
                        for (var i in posCounter) {
                            if (posCounter[i] > 1 && i !== "undefined") {
                                hAlert( $filter("translate")("Error"),
                                    $filter("translate")("Duplicated positions exist.")
                                );
                                $scope.loading = false;
                                return;
                            }
                        }

                        $scope.editRolesForm.save()
                            .then(function () {

                                if ($scope.roles.roles && $scope.roles.roles.length > 0) {
                                    for (var i = 0; i < $scope.roles.roles.length; i++) {
                                        var role = $scope.roles.roles[i];

                                        if (role && role.position && role.position.code) {
                                            var obj = {
                                                position_code: role.position.code,
                                                is_tipped: role.is_tipped
                                            };

                                            if (role.allow_rate_access) {
                                                role.pay_rate = role.pay_rate || {};
                                                role.pay_rate.rate = role.pay_rate.rate || 0.00;
                                                role.pay_rate.currency = role.pay_rate.currency || "";

                                                obj['pay_rate'] = role.pay_rate;

                                                if ($scope.isClockTimeEnabled &&
                                                    (
                                                        ['ADP', 'PAYLOCITY', 'BENEFIT_MALL', 'ACCUDATA'].indexOf($scope.brand.paysheet_payroll_type) > -1
                                                    )
                                                ) {
                                                    if (role.pay_rate && role.pay_rate.pay_rate_code) {
                                                        obj['pay_rate_code_id'] = role.pay_rate.pay_rate_code.id;
                                                    }
                                                } else {
                                                    delete role.pay_rate.pay_rate_code;
                                                }
                                            }

                                            if (
                                                role.cost_center
                                            ) {

                                                if (
                                                    role.cost_center.value &&
                                                    role.cost_center.value.id
                                                ) {
                                                    delete role.cost_center.name;
                                                    delete role.cost_center.value.name;
                                                } else {
                                                    role.cost_center.value = {
                                                        id: null
                                                    }
                                                }

                                                var cost_brand_center = angular.copy($scope.brand.cost_center);
                                                cost_brand_center = cost_brand_center || {};

                                                obj['cost_center'] =  role.cost_center;
                                                obj['cost_center'].id = obj['cost_center'].id || cost_brand_center.id;
                                            }

                                            updatedRoles.roles.push(obj);
                                        }
                                    }
                                }

                                if (JSON.stringify($scope.roles) != JSON.stringify($scope.originalRoles)) {

                                    TeamAPI.saveMemberRoles($scope.brandId, $scope.member.id, updatedRoles)
                                        .then(function (roles) {

                                            $scope.isEditing = false;
                                            $scope.loading = false;
                                            $scope.showRoles();
                                            TeamScheduleService.triggerRatesUpdated();

                                            $scope.$digest();
                                        }, function (error) {
                                            console.error(error);
                                            $scope.isEditing = false;
                                            $scope.loading = false;
                                            hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong while editing Positions and Wages"));
                                            $scope.$digest();
                                        });
                                }

                            }, function () {

                                $scope.loading = false;
                                $scope.isRolesShown = false;

                                try {
                                    $scope.$digest();
                                } catch (e) {
                                }

                            });
                    };

                    /**
                     * Show edit roles form
                     */
                    $scope.editRoles = function (newPosition) {

                        $scope.loading = true;
                        $scope.positions = [];

                        var promises = {positions: TeamAPI.getBrandActiveCategoriesPosition($scope.brandId)};

                        if ($scope.isClockTimeEnabled &&
                            (
                                ['ADP', 'PAYLOCITY', 'BENEFIT_MALL', 'ACCUDATA'].indexOf($scope.brand.paysheet_payroll_type) > -1
                            )
                        ) {
                            var payrollPromise = TeamAPI.getPayrollCodeRates($scope.brandId, $scope.member.id);
                            promises['payroll_codes'] = payrollPromise;
                        }

                        $q.all(promises)
                            .then(function (res) {
                                var positions = res.positions;
                                var payroll_codes = res.payroll_codes;

                                if (payroll_codes) {
                                    $scope.payrollCodes = [];

                                    payroll_codes.pay_rate_codes = payroll_codes.pay_rate_codes || [];

                                    payroll_codes.pay_rate_codes.forEach(function (rate) {
                                        delete rate.rate;
                                    });

                                    $scope.payrollCodes = payroll_codes.pay_rate_codes;
                                }

                                positions.positions_categories = positions.positions_categories || [];

                                $scope.loading = false;

                                for (var i = 0; i < positions.positions_categories.length; i++) {
                                    var cat = positions.positions_categories[i];

                                    for (var x = 0; x < cat.positions.length; x++) {

                                        var newPosition = {};

                                        newPosition['category'] = {
                                            code: cat.code,
                                            id: cat.id,
                                            name: cat.name
                                        };

                                        newPosition["code"] = cat.positions[x].code;
                                        newPosition["id"] = cat.positions[x].id;
                                        newPosition["name"] = cat.positions[x].name;

                                        $scope.positions.push(newPosition);
                                    }
                                }

                                try {
                                    $scope.$digest();
                                } catch (e) {
                                }

                            }, function (error) {

                                $scope.loading = false;
                                console.error(error);

                            });

                        $scope.editRolesForm.load({isADPRate: (
                            $scope.isClockTimeEnabled &&
                            ['ADP', 'BENEFIT_MALL'].indexOf($scope.brand.paysheet_payroll_type) > -1
                        ), roles: $scope.roles}, newPosition);
                        $scope.isEditing = true;
                    };

                    /**
                     * Cancel changes and revert to original roles and wages data
                     */
                    $scope.revertRoles = function () {

                        $scope.roles = angular.copy($scope.originalRoles);
                        $scope.editRolesForm.load({roles: $scope.roles});
                        $scope.isEditing = false;

                    };

                    $scope.showMemberProfile = function () {
                        _tcService.showMemberProfile($scope.brandId, $scope.member.id);
                    };

                }
            };
        }]);
})(TeamAPI, TeamScheduleAPI, _);
